const t = {
  name: "MagneticSwipe",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 10C0 7.23772 2.23772 5 5 5H19C21.7623 5 24 7.23772 24 10V19H22V15H2V19H0V10ZM2 13H22V11H2V13ZM19 7H5C3.69298 7 2.58204 7.83443 2.17049 9H21.8295C21.418 7.83443 20.307 7 19 7Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as MagneticSwipe
};
